var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "attached-photo-row"
  }, [_vm._l(_vm.images, function (url, i) {
    return _c('div', {
      key: i,
      staticClass: "attached-photo-row__el",
      on: {
        "click": function ($event) {
          return _vm.showPhotoSwipe(i);
        }
      }
    }, [_c('img', {
      ref: "photo",
      refInFor: true,
      staticClass: "attached-photo-row__photo",
      attrs: {
        "src": url
      }
    })]);
  }), _vm._v(" "), _c('Photoswipe', {
    attrs: {
      "is-open": _vm.open,
      "items": _vm.items,
      "options": {
        index: _vm.index
      }
    },
    on: {
      "close": function ($event) {
        _vm.open = false;
      }
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }